import { isWeekendDay } from "../../../helpers/utils/calendar.util";

const validateStartDate = (start: Date, end?: Date): string | undefined => {
  if (isWeekendDay(start)) {
    return "Wochenende ist ungültig";
  }
  if (end && new Date(start) > new Date(end)) {
    return "Datum muss früher als Ende sein";
  }
  return undefined;
};

const validateEndDate = (end: Date, start?: Date): string | undefined => {
  if (isWeekendDay(end)) {
    return "Wochenende ist ungültig";
  }
  if (start && new Date(end) < new Date(start)) {
    return "Datum muss später als Start sein";
  }
  return undefined;
};

export { validateStartDate, validateEndDate };
